import { render, staticRenderFns } from "./ShuiWu1.vue?vue&type=template&id=12b6adca&scoped=true&"
import script from "./ShuiWu1.vue?vue&type=script&lang=js&"
export * from "./ShuiWu1.vue?vue&type=script&lang=js&"
import style0 from "./ShuiWu1.vue?vue&type=style&index=0&id=12b6adca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b6adca",
  null
  
)

export default component.exports